import { Navigate, Outlet } from "react-router-dom";
import { useAdminAuth } from "@/contexts/AdminAuthContext";
import { AdminSidebar } from "@/components/admin/AdminSidebar";

export function AdminShell() {
  const { isAdmin } = useAdminAuth();
  if (!isAdmin) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto flex max-w-6xl px-3 md:px-6">
        <AdminSidebar />
        <main className="flex-1 min-w-0 py-4 md:py-6 md:pl-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
